export { default } from './StockTabs';
